


<section hidden="true">
	<h2 class="text-center header-title"> <b>Custom Quote</b> </h2>
	<div class="container mt-1 mb-1 border-0" *ngIf="this.checkAll==true">
	<div class="text-center alert alert-danger fwbold" role="alert">Please fill all mandatory fields (Asterisk *) to get a Quote</div>
	</div>
	<div class="container sub-text border-0 mt-2">
		<strong>If you have any requirements regarding the PCB layout, use this simple form to get a Custom Quote for your PCB design services. Simply provide a few details, tell us the turn time needed, and upload the required supporting files!</strong>
	</div>
	
	<p class="text-center mt-2"></p>
	<div class="container" role="main">
		<!-- <div class="card-container">
			<div class="container-title">Personal Information</div>
			<div class="row g-3 mt-3">
				<div class="col-12">
					<form class="needs-validation" novalidate [formGroup]="personalForm" autocomplete="off">
						<div class="mb-3 row">
							<label for="fname" class="col-sm-2 col-form-label">Name</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" id="fname" autocomplete="off" placeholder="First Name" formControlName="firstName" [(ngModel)]="personalRep.firstName" required name="firstName" [class.invalid]="!personalForm.controls.firstName.valid && personalForm.controls.firstName.dirty"/>
							</div>
							<div class="col-sm-4">
								<input type="text" class="form-control" id="lname" placeholder="Last Name" formControlName="lastName"  [(ngModel)]="personalRep.lastName" required [class.invalid]="!personalForm.controls.lastName.valid && personalForm.controls.lastName.dirty" autocomplete="new-lastName"/>
							</div>
						</div>
						<div class="mb-3 row">
							<label for="company" class="col-sm-2 col-form-label">Company</label>
							<div class="col-sm-10">
								<input type="text" class="form-control" id="company" placeholder="Enter your company name" formControlName="companyName" [(ngModel)]="personalRep.companyName" required name="companyname" [class.invalid]="!personalForm.controls.companyName.valid && personalForm.controls.companyName.dirty" autocomplete="new-companyName"/>
							</div>
						</div>
						<div class="mb-3 row">
							<label for="email" class="col-sm-2 col-form-label">Email</label>
							<div class="col-sm-10">
								<input type="text" class="form-control" id="email" placeholder="Enter your valid email address" formControlName="email" [(ngModel)]="personalRep.email" required [class.invalid]="!personalForm.controls.email.valid && personalForm.controls.email.dirty" autocomplete="new-email"/>
							</div>
						</div>
						<div class="mb-3 row">
							<label for="inputPhone" class="col-sm-2 col-form-label">Phone</label>
							<div class="col-sm-10">
								<input type="phone" class="form-control" placeholder="Enter your phone" formControlName="phoneNumber" [(ngModel)]="personalRep.phoneNumber" id="phone" required [class.invalid]="!personalForm.controls.phoneNumber.valid && personalForm.controls.phoneNumber.dirty" autocomplete="new-phoneNo" numbersOnly/>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div> -->
		<form class="needs-validation" novalidate [formGroup]="generalForm" autocomplete="off">
			<div class="card-container">
				<div class="container-title fwbold">General</div>
				<div class="row g-3 mt-3">
					<div class="col-12">
						<!-- <form> -->
							<div class="mb-3 row">
								<label for="itar" class="col-sm-6 col-form-label">Need ITAR Compliance:<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-2 offset-md-1">
									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="1" id="flexRadioDefault1" formControlName="designITAR" [(ngModel)]="generalRep.designITAR" required [class.invalid]="!generalForm.controls.designITAR.valid && generalForm.controls.designITAR.dirty"/>
									    <label class="form-check-label" for="flexRadioDefault1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="2" id="flexRadioDefault2" formControlName="designITAR" [(ngModel)]="generalRep.designITAR" required [class.invalid]="!generalForm.controls.designITAR.valid && generalForm.controls.designITAR.dirty"/>
									    <label class="form-check-label" for="flexRadioDefault2">No</label>
									  </li>
									</ul>
								</div>
							</div>


							<div class="mb-3 row">
								<label for="a" class="col-sm-6 col-form-label">Design Board Name:<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">
									<input type="text" class="form-control" id="dboard" placeholder="Design Board Name" formControlName="pcbPartNumber" [(ngModel)]="generalRep.pcbPartNumber" required [class.invalid]="!generalForm.controls.pcbPartNumber.valid && generalForm.controls.pcbPartNumber.dirty" maxlength="100">
									<!-- <div *ngIf="!generalForm.controls.pcbPartNumber.valid && generalForm.controls.pcbPartNumber.dirty && !generalRep.pcbPartNumber" class="error-message">
							  	Design Board Name is required.
							</div> -->
								</div>

								<label for="esd" class="col-sm-6 col-form-label">Expected Start Date:<span class="require-mark">&lowast;</span> <div class="fsit fs12">(Note: Subject to the date of receiving the Purchase order)</div></label>
								<div class="col-sm-4 pt-2 offset-md-1">
									<div style="width: 100%;display: inline-block;">
									  	<div class="input-group">
								            <!-- <input class="form-control" placeholder="mm/dd/yyyy" id="esd" name="ds" formControlName="expectedStartDate" [(ngModel)]="generalRep.expectedStartDate" ngbDatepicker #d1="ngbDatepicker" /> -->
											<input class="form-control custom-field" placeholder="mm/dd/yyyy" id="esd" name="ds" formControlName="expectedStartDate" [(ngModel)]="generalRep.expectedStartDate" [dayTemplate]="exStartDate" ngbDatepicker #d1="ngbDatepicker" autocomplete="off" readonly >
								            
											<!-- -->
								            <div class="input-group-append">
								              <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button">📅</button>
								            </div>
								        </div>
									</div>
								</div>

								<label for="b" class="col-sm-6 col-form-label">Expected Completion Date:<span class="require-mark">&lowast;</span> <div class="fsit fs12">(Note: Subject to the date of receiving the Purchase order)</div></label>
								<div class="col-sm-4 pt-2 offset-md-1">
									<div style="width: 100%;display: inline-block;">
									  	<div class="input-group">
								            <!-- <input class="form-control" placeholder="mm/dd/yyyy" id="ecd" name="dc" formControlName="expectedComplitionDate" [(ngModel)]="generalRep.expectedComplitionDate" ngbDatepicker #d2="ngbDatepicker" autocomplete="off" /> -->
											<input class="form-control custom-field" placeholder="mm/dd/yyyy" id="ecd" name="dc" formControlName="expectedComplitionDate" [(ngModel)]="generalRep.expectedComplitionDate" [dayTemplate]="exEndDate"  ngbDatepicker #d2="ngbDatepicker" autocomplete="off" [minDate]="expComMinDate" readonly>
											<!--  [maxDate]="maxDate" [minDate]="minDate" -->
								            <div class="input-group-append">
								              <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">📅</button>
												
											</div>
								        </div>
									</div>
								</div>

								<ng-template #exStartDate let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
									<span class="custom-day" [class.focused]="date.day"
										  [class.bg-primary]="selected"  (click)="exStartDateChange(date)" [class.hidden]="date.day" [class.text-muted]="date.day == selected.day">
									  {{ date.day }}
									</span>
								  </ng-template>
								
								  <ng-template #exEndDate let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
									<span class="custom-day" [class.focused]="date.day"
										  [class.bg-primary]="selected" (click)="exEndDateChange(date)" [class.hidden]="date.day" [class.text-muted]="date.day == selected.day">
									  {{ date.day }}
									</span>
								  </ng-template>

								<label for="c" class="col-sm-6 col-form-label">Scope of design:<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">
									<!-- <label for="slayout" class="col-sm-6 col-form-label">a. schematic to layout </label>
									<div class="col-sm-4 pt-2">
										<input type="checkbox" class="form-control" id="slayout" placeholder="Design Board Name"/>
									</div> -->

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex">
									    <label class="form-check-label" for="scopedesignschematic">a. Schematic to layout</label>
									    <input type="radio" value="1" class="form-check-input me-1 float-end radio-options" id="scopedesignschematic" formControlName="scopeOfDesign" [(ngModel)]="generalRep.scopeOfDesign" />
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="scopedesignconcept">b. Concept to layout</label>
									    <input type="radio" value="2" class="form-check-input me-1 float-end radio-options" id="scopedesignconcept" formControlName="scopeOfDesign" [(ngModel)]="generalRep.scopeOfDesign" />
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="scopedesignblock">c. Block diagram to layout</label>
									    <input type="radio" value="3" class="form-check-input me-1 float-end radio-options" id="scopedesignblock" formControlName="scopeOfDesign" [(ngModel)]="generalRep.scopeOfDesign" />
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="scopedesigncompletion">d. Layout started to completion</label>
									    <input type="radio" value="4" class="form-check-input me-1 float-end radio-options" id="scopedesigncompletion" formControlName="scopeOfDesign" [(ngModel)]="generalRep.scopeOfDesign" />
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <div class="me-auto" style="width: 100%;">
									      <div class="d-flex">
									      	<label class="form-check-label" for="scopedesignother">e. Others</label>
									    		<input type="radio" value="5" class="form-check-input me-1 float-end radio-options" id="scopedesignother" formControlName="scopeOfDesign" [(ngModel)]="generalRep.scopeOfDesign" />
									    	</div>
									      <textarea class="form-control textarea-height me-1 float-end mt-2" for="scopedesignother" formControlName="scopeOfDesign_otherNotes" [(ngModel)]="generalRep.scopeOfDesign_otherNotes" (keyup)="onInputCheck($event,'scopeOfDesign_otherNotes',generalForm.get('scopeOfDesign_otherNotes')?.errors?.maxlength?.requiredLength)"  *ngIf="generalRep.scopeOfDesign == '5'"></textarea>
									    </div>
									  </li>
									</ul>
								</div>
							</div>
						<!-- </form> -->
					</div>
				</div>
			</div>
			<div class="card-container">
				<div class="container-title fwbold">Design Inputs</div>
				<div class="row g-3 mt-3"  style="width:100%;">
					<div class="col-12">
						<!-- <form> -->
							<div class="mb-3 row">
								<label for="d" class="col-sm-6 col-form-label">Does the project have an Statement of work (SOW)?:<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-2 offset-md-1">
									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="1" id="flexRadioSow1" formControlName="isStatementOfWorkSOW" [(ngModel)]="generalRep.isStatementOfWorkSOW" required [class.invalid]="!generalForm.controls.isStatementOfWorkSOW.valid && generalForm.controls.isStatementOfWorkSOW.dirty"/>
									    <label class="form-check-label" for="flexRadioSow1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="2" id="flexRadioSow2" formControlName="isStatementOfWorkSOW" [(ngModel)]="generalRep.isStatementOfWorkSOW" required [class.invalid]="!generalForm.controls.isStatementOfWorkSOW.valid && generalForm.controls.isStatementOfWorkSOW.dirty"/>
									    <label class="form-check-label" for="flexRadioSow2">No</label>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="e" class="col-sm-6 col-form-label">Is Bill of material available?:<span class="require-mark">&lowast;</span><div class="fsit fs12">(Select from the Options)</div></label>
								<div class="col-sm-2 offset-md-1">
									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="YES" id="flexRadioBom1" formControlName="billOfMaterialType" [(ngModel)]="generalRep.billOfMaterialType" required [class.invalid]="!generalForm.controls.billOfMaterialType.valid && generalForm.controls.billOfMaterialType.dirty"/>
									    <label class="form-check-label" for="flexRadioBom1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="NO" id="flexRadioBom2" formControlName="billOfMaterialType" [(ngModel)]="generalRep.billOfMaterialType" required [class.invalid]="!generalForm.controls.billOfMaterialType.valid && generalForm.controls.billOfMaterialType.dirty"/>
									    <label class="form-check-label" for="flexRadioBom2">No</label>
									  </li>
									</ul>
								</div>
								<div class="col-sm-2" *ngIf="generalRep.billOfMaterialType == 'YES'">
									<!-- <div class="col-sm-4 dib">					
										<div class="d-flex mt-2">
											<input type="checkbox" class="form-check-input me-1"/>
										</div>
										<label for="bompdf" class="col-sm-4 col-form-label p-0">PDF</label>

									</div>
									<div class="col-sm-4 dib">
										<div class="d-flex mt-2">
											<input type="checkbox" class="form-check-input me-1"/>
										</div>
										<label for="bomcsv" class="col-sm-4 col-form-label p-0">CSV</label>
									</div>
									<div class="col-sm-4 dib">
										<div class="d-flex mt-2">
											<input type="checkbox" class="form-check-input me-1"/>
										</div>
										<label for="bomex" class="col-sm-4 col-form-label p-0">Excel</label>
									</div> -->
									
									<select class="form-select" aria-label="Default select example" #bom (change)="onBomSelected(bom.value)" required >
										<option selected>select</option>
										<option value="1">PDF</option>
										<option value="2">CSV</option>
										<option value="3">Excel</option>
									</select>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="f" class="col-sm-6 col-form-label">Is the Schematic available for the design?<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-2 offset-md-1">
									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="1" id="flexRadioSad1" formControlName="isTheSchematicAvailableForTheDesign" [(ngModel)]="generalRep.isTheSchematicAvailableForTheDesign" required [class.invalid]="!generalForm.controls.isTheSchematicAvailableForTheDesign.valid && generalForm.controls.isTheSchematicAvailableForTheDesign.dirty"/>
									    <label class="form-check-label" for="flexRadioSad1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="2" id="flexRadioSad2" formControlName="isTheSchematicAvailableForTheDesign" [(ngModel)]="generalRep.isTheSchematicAvailableForTheDesign" required [class.invalid]="!generalForm.controls.isTheSchematicAvailableForTheDesign.valid && generalForm.controls.isTheSchematicAvailableForTheDesign.dirty"/>
									    <label class="form-check-label" for="flexRadioSad2">No</label>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="i" class="col-sm-6 col-form-label"> Select the format of the Schematic design or mention any other format. <span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">
									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex ">
									    <label class="form-check-label" for="schmaticradio1">a. PDF</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio1" value="1" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio2">b. ALLEGRO/ORCAD</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio2" value="2" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio3">c. ALTIUM</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio3" value="3" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio4">d. KICAD</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="7" id="schmaticradio4" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>

									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio5">e. PADS</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio5" value="4" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>

									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio6">f. EAGLE</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio6" value="5" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio7">g. HAND DRAWN</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio7" value="8" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="schmaticradio8">h. NONE</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="schmaticradio8" value="6" formControlName="formatOfTheSchematicDesign" [(ngModel)]="generalRep.formatOfTheSchematicDesign" required [class.invalid]="!generalForm.controls.formatOfTheSchematicDesign.valid && generalForm.controls.formatOfTheSchematicDesign.dirty"/>
									  </li>
									  <!-- <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <div class="me-auto" style="width: 100%;">
									      <div>g. Others</div>
									      <textarea class="form-control me-1 float-end"></textarea>
									    </div>
									  </li> -->
									</ul>
								</div>
							</div>

							<div class="mb-3 row">
								<label for="j" class="col-sm-6 col-form-label">Is a block diagram of the design available?<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-2 offset-md-1">
									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="1" id="flexRadioBdd1" formControlName="isABlockDiagramOfTheDesignAvailable" [(ngModel)]="generalRep.isABlockDiagramOfTheDesignAvailable" required [class.invalid]="!generalForm.controls.isABlockDiagramOfTheDesignAvailable.valid && generalForm.controls.isABlockDiagramOfTheDesignAvailable.dirty"/>
									    <label class="form-check-label" for="flexRadioBdd1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="2" id="flexRadioBdd2" formControlName="isABlockDiagramOfTheDesignAvailable" [(ngModel)]="generalRep.isABlockDiagramOfTheDesignAvailable" required [class.invalid]="!generalForm.controls.isABlockDiagramOfTheDesignAvailable.valid && generalForm.controls.isABlockDiagramOfTheDesignAvailable.dirty"/>
									    <label class="form-check-label" for="flexRadioBdd2">No</label>
									  </li>
									</ul>
								</div>
							</div>

							<div class="mb-3 row">
								<label for="k" class="col-sm-6 col-form-label">Do you want us to develop schematic from Block diagram provided by you?<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-2 offset-md-1">
									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="1" id="flexRadioDbd1" formControlName="developSchematicFromBlockDiagram" [(ngModel)]="generalRep.developSchematicFromBlockDiagram" required [class.invalid]="!generalForm.controls.developSchematicFromBlockDiagram.valid && generalForm.controls.developSchematicFromBlockDiagram.dirty"/>
									    <label class="form-check-label" for="flexRadioDbd1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="2" id="flexRadioDbd2" formControlName="developSchematicFromBlockDiagram" [(ngModel)]="generalRep.developSchematicFromBlockDiagram" required [class.invalid]="!generalForm.controls.developSchematicFromBlockDiagram.valid && generalForm.controls.developSchematicFromBlockDiagram.dirty"/>
									    <label class="form-check-label" for="flexRadioDbd2">No</label>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="l" class="col-sm-6 col-form-label">How would you describe your board?<span class="require-mark">&lowast;</span> <div class="fsit fs12"> (Select the relevant design) </div></label>
								<div class="col-sm-4 offset-sm-1">

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex ">
									    <label class="form-check-label" for="describeboard1">a. High Voltage(>50V) design?</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="1" id="describeboard1" formControlName="describeYourBoard" [(ngModel)]="generalRep.describeYourBoard" required [class.invalid]="!generalForm.controls.describeYourBoard.valid && generalForm.controls.describeYourBoard.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="describeboard2">b. High frequency Board? </label> 
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="2" id="describeboard2" formControlName="describeYourBoard" [(ngModel)]="generalRep.describeYourBoard" required [class.invalid]="!generalForm.controls.describeYourBoard.valid && generalForm.controls.describeYourBoard.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="describeboard3">c. RF board?</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="3" id="describeboard3" formControlName="describeYourBoard" [(ngModel)]="generalRep.describeYourBoard" required [class.invalid]="!generalForm.controls.describeYourBoard.valid && generalForm.controls.describeYourBoard.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="describeboard4">d. High Current (>1amp) board?</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="4" id="describeboard4" formControlName="describeYourBoard" [(ngModel)]="generalRep.describeYourBoard" required [class.invalid]="!generalForm.controls.describeYourBoard.valid && generalForm.controls.describeYourBoard.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">

									    <div class="me-auto" style="width: 100%;">
									      <div class="d-flex">
									      	<label class="form-check-label" for="describeboardother">e. Any other? Please describe</label>
									    		<input type="radio" value="5" class="form-check-input me-1 float-end radio-options" id="describeboardother" formControlName="describeYourBoard" [(ngModel)]="generalRep.describeYourBoard" required [class.invalid]="!generalForm.controls.describeYourBoard.valid && generalForm.controls.describeYourBoard.dirty" />
									    	</div>
									      <textarea class="form-control textarea-height me-1 float-end mt-2" formControlName="describeYourBoard_otherNotes" [(ngModel)]="generalRep.describeYourBoard_otherNotes" required [class.invalid]="!generalForm.controls.describeYourBoard_otherNotes.valid && generalForm.controls.describeYourBoard_otherNotes.dirty" (keyup)="onInputCheck($event,'describeYourBoard_otherNotes',generalForm.get('describeYourBoard_otherNotes')?.errors?.maxlength?.requiredLength)"   *ngIf="generalRep.describeYourBoard == '5'"></textarea>
									    </div>
									  </li>
									</ul>
								</div>
							</div>

							<div class="mb-3 row">
								<label for="m" class="col-sm-6 col-form-label">Does the circuit have high frequency signals requiring impedance matching?<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex">
									    <label class="form-check-label" for="highfreq1">a. 50E  SE single ended </label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="highfreq1" value="1" formControlName="circuitHaveHighFrequencySignals" [(ngModel)]="generalRep.circuitHaveHighFrequencySignals" required [class.invalid]="!generalForm.controls.circuitHaveHighFrequencySignals.valid && generalForm.controls.circuitHaveHighFrequencySignals.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="highfreq2">b. 100E  DIF Differential</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="highfreq2" value="2" formControlName="circuitHaveHighFrequencySignals" [(ngModel)]="generalRep.circuitHaveHighFrequencySignals" required [class.invalid]="!generalForm.controls.circuitHaveHighFrequencySignals.valid && generalForm.controls.circuitHaveHighFrequencySignals.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">

									    <div class="me-auto" style="width: 100%;">
									      <div class="d-flex">
									      	<label class="form-check-label" for="highfreqother">c. Any other Differential lines?</label>
									      	<input type="radio" value="3" class="form-check-input me-1 float-end radio-options" id="highfreqother" formControlName="circuitHaveHighFrequencySignals" [(ngModel)]="generalRep.circuitHaveHighFrequencySignals" required [class.invalid]="!generalForm.controls.circuitHaveHighFrequencySignals.valid && generalForm.controls.circuitHaveHighFrequencySignals.dirty" />
									      </div>
									      <textarea class="form-control textarea-height me-1 float-end mt-2" formControlName="circuitHaveHighFrequencySignals_otherNotes" [(ngModel)]="generalRep.circuitHaveHighFrequencySignals_otherNotes" required [class.invalid]="!generalForm.controls.circuitHaveHighFrequencySignals_otherNotes.valid && generalForm.controls.circuitHaveHighFrequencySignals_otherNotes.dirty" (keyup)="onInputCheck($event,'circuitHaveHighFrequencySignals_otherNotes',generalForm.get('circuitHaveHighFrequencySignals_otherNotes')?.errors?.maxlength?.requiredLength)"  *ngIf="generalRep.circuitHaveHighFrequencySignals == '3'"></textarea>
									    </div>
									  </li>
									</ul>
								</div>
							</div>
						<!-- </form> -->
					</div>
				</div>
			</div>
			<div class="card-container">
				<div class="container-title fwbold">BOARD related questions</div>
				<div class="row g-3 mt-3">
					<div class="col-12">
						<!-- <form> -->
							<div class="mb-3 row">
								<label for="o" class="col-sm-6 col-form-label">What is the size of the Board outline.<span class="require-mark">&lowast;</span><div  class="fsit fs12"> (Note: size of Rectangle in which the board outline will fit)</div></label>
								<div class="col-sm-2 pt-2 offset-md-1">
									<input type="text" class="form-control" id="sbx" placeholder="X  (inches)" formControlName="indBoardXDim" [(ngModel)]="generalRep.indBoardXDim" required [class.invalid]="!generalForm.controls.indBoardXDim.valid && generalForm.controls.indBoardXDim.dirty" >
								</div>
								<div class="col-sm-2 pt-2">
									<input type="text" class="form-control" id="sby" placeholder="Y  (inches)" formControlName="indBoardYDim" [(ngModel)]="generalRep.indBoardYDim" required [class.invalid]="!generalForm.controls.indBoardYDim.valid && generalForm.controls.indBoardYDim.dirty" >
								</div>
							</div>
							<div class="mb-3 row">
								<label for="p" class="col-sm-6 col-form-label"> Is drawing with board outline guideline available?<span class="require-mark">&lowast;</span> <div class="fsit fs12">(Format of Drawing)</div></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex">
									    <label class="form-check-label" for="guideboarddxf">a. DXF</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="1" id="guideboarddxf" formControlName="boardOutlineGuidelineAvailable" [(ngModel)]="generalRep.boardOutlineGuidelineAvailable" required [class.invalid]="!generalForm.controls.boardOutlineGuidelineAvailable.valid && generalForm.controls.boardOutlineGuidelineAvailable.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="guideboardword">b. Word / PDF/ JPG Document</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="2" id="guideboardword" formControlName="boardOutlineGuidelineAvailable" [(ngModel)]="generalRep.boardOutlineGuidelineAvailable" required [class.invalid]="!generalForm.controls.boardOutlineGuidelineAvailable.valid && generalForm.controls.boardOutlineGuidelineAvailable.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">

									    <div class="me-auto" style="width: 100%;">
									      <div class="d-flex">
									      	<label class="form-check-label" for="guideboardother">c. Any other?</label>
									      	<input type="radio" value="3" class="form-check-input me-1 float-end radio-options" id="guideboardother" formControlName="boardOutlineGuidelineAvailable" [(ngModel)]="generalRep.boardOutlineGuidelineAvailable" required [class.invalid]="!generalForm.controls.boardOutlineGuidelineAvailable.valid && generalForm.controls.boardOutlineGuidelineAvailable.dirty" />
									      </div>
									      <textarea class="form-control textarea-height me-1 float-end mt-2" formControlName="boardOutlineGuidelineAvailable_otherNotes" [(ngModel)]="generalRep.boardOutlineGuidelineAvailable_otherNotes" required [class.invalid]="!generalForm.controls.boardOutlineGuidelineAvailable_otherNotes.valid && generalForm.controls.boardOutlineGuidelineAvailable_otherNotes.dirty"  (keyup)="onInputCheck($event,'boardOutlineGuidelineAvailable_otherNotes',generalForm.get('boardOutlineGuidelineAvailable_otherNotes')?.errors?.maxlength?.requiredLength)"  *ngIf="generalRep.boardOutlineGuidelineAvailable == '3'"></textarea>
									    </div>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="q" class="col-sm-6 col-form-label"> Is there a document describing required details of the board such as the positions of Connector positions, mounting hole positions(constraints) etc?<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="1" id="docRadioDefault1" formControlName="docForDetailsOfTheBoard" [(ngModel)]="generalRep.docForDetailsOfTheBoard" required [class.invalid]="!generalForm.controls.docForDetailsOfTheBoard.valid && generalForm.controls.docForDetailsOfTheBoard.dirty"/>
									    <label class="form-check-label" for="docRadioDefault1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="2" id="docRadioDefault2" formControlName="docForDetailsOfTheBoard" [(ngModel)]="generalRep.docForDetailsOfTheBoard" required [class.invalid]="!generalForm.controls.docForDetailsOfTheBoard.valid && generalForm.controls.docForDetailsOfTheBoard.dirty"/>
									    <label class="form-check-label" for="docRadioDefault2">No</label>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="r" class="col-sm-6 col-form-label"> Are there any constraints on the placement of connectors,IC,mounting holes? <span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0" style="display: inline-block;">
									    <input type="radio" class="form-check-input me-1" value="1" id="icmRadioDefault1" formControlName="constraintsOnICMountingHoles" [(ngModel)]="generalRep.constraintsOnICMountingHoles" required [class.invalid]="!generalForm.controls.constraintsOnICMountingHoles.valid && generalForm.controls.constraintsOnICMountingHoles.dirty"/>
									    <label class="form-check-label" for="icmRadioDefault1">Yes</label>
									  </li>
									  <li class="list-group-item border-0" style="display: inline-block;">
									    <input type="radio" class="form-check-input me-1" value="2" id="icmRadioDefault2" formControlName="constraintsOnICMountingHoles" [(ngModel)]="generalRep.constraintsOnICMountingHoles" required [class.invalid]="!generalForm.controls.constraintsOnICMountingHoles.valid && generalForm.controls.constraintsOnICMountingHoles.dirty"/>
									    <label class="form-check-label" for="icmRadioDefault2">No</label>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="s" class="col-sm-6 col-form-label"> Is maximum height is required on the top and bottom layer? <span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0" style="display: inline-block;">
									    <input type="radio" class="form-check-input me-1" value="1" id="maxhRadioDefault1" formControlName="maxHeightOnTheTopAndBottomLayer" [(ngModel)]="generalRep.maxHeightOnTheTopAndBottomLayer" required [class.invalid]="!generalForm.controls.maxHeightOnTheTopAndBottomLayer.valid && generalForm.controls.maxHeightOnTheTopAndBottomLayer.dirty"/>
									    <label class="form-check-label" for="maxhRadioDefault1">Yes</label>
									  </li>
									  <li class="list-group-item border-0" style="display: inline-block;">
									    <input type="radio" class="form-check-input me-1" value="2" id="maxhRadioDefault2" formControlName="maxHeightOnTheTopAndBottomLayer" [(ngModel)]="generalRep.maxHeightOnTheTopAndBottomLayer" required [class.invalid]="!generalForm.controls.maxHeightOnTheTopAndBottomLayer.valid && generalForm.controls.maxHeightOnTheTopAndBottomLayer.dirty"/>
									    <label class="form-check-label" for="maxhRadioDefault2">No</label>
									  </li>
									</ul>
								</div>
							</div>

							<div class="mb-3 row">
								<label class="col-sm-6 col-form-label">Are the Number of layers on board known?If Yes, How many layers ? <span class="require-mark">&lowast;</span></label>
								<div class="col-sm-2 offset-md-1">

									<ul class="list-group" style="display: block;">
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="YES" id="nolRadioDefault1" formControlName="layers" [(ngModel)]="generalRep.layers" required [class.invalid]="!generalForm.controls.layers.valid && generalForm.controls.layers.dirty"/>
									    <label class="form-check-label" for="nolRadioDefault1">Yes</label>
									  </li>
									  <li class="list-group-item border-0 dib">
									    <input type="radio" class="form-check-input me-1" value="NO" id="nolRadioDefault2" formControlName="layers" [(ngModel)]="generalRep.layers" required [class.invalid]="!generalForm.controls.layers.valid && generalForm.controls.layers.dirty"/>
									    <label class="form-check-label" for="nolRadioDefault2">No</label>
									  </li>
									</ul>
								</div>
								<div class="col-sm-2 pt-2" *ngIf="generalRep?.layers=='YES'">
									<select class="form-select" aria-label="Default select example" #layerSelect (change)="onSelected(layerSelect.value)" required>
									  <option selected>select</option>
									  <option value="{{lay.id}}" *ngFor="let lay of layersData">{{lay.name}}</option>
									</select>
								</div>
							</div>

							<div class="mb-3 row">
								<label class="col-sm-6 col-form-label">What is the thickness of the Board? <span class="require-mark">&lowast;</span> <div class="fsit fs12">(Default thickness is 0.062 inches. Kindly specify if any other thickness is needed.)</div></label>
								
								<div class="col-sm-2 pt-2 offset-md-1">
									<select class="form-select" aria-label="Default select example" formControlName="thicknessOfTheBoard" [(ngModel)]="generalRep.thicknessOfTheBoard" required [class.invalid]="!generalForm.controls.thicknessOfTheBoard.valid && generalForm.controls.thicknessOfTheBoard.dirty">
									  <option [selected]="generalRep.thicknessOfTheBoard=='0'">select</option>
									  <option value="1">0.031 inches</option>
									  <option value="2">0.032 inches</option>
									  <option value="3">0.039 inches</option>
									  <option value="4">0.049 inches</option>
									  <option value="5">0.062 inches</option>
									  <option value="6">0.076 inches</option>
									  <option value="7">0.093 inches</option>
									  <option value="8">Other</option>
									</select>
								</div>
								<div class="col-sm-2 pt-2" *ngIf="generalRep.thicknessOfTheBoard == '8'">
									<input type="text" class="form-control" formControlName="thicknessOfTheBoard_otherNotes" [(ngModel)]="generalRep.thicknessOfTheBoard_otherNotes" maxlength="250" required [class.invalid]="!generalForm.controls.thicknessOfTheBoard_otherNotes.valid && generalForm.controls.thicknessOfTheBoard_otherNotes.dirty" />
								</div>
							</div>


							<div class="mb-3 row">
								<label for="t" class="col-sm-6 col-form-label">Please specify in case design require any of the following.<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex">
									    <label class="form-check-label" for="casedesignreq1">a. Rigid board</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="1" id="casedesignreq1" formControlName="pcbTypeForDesign" [(ngModel)]="generalRep.pcbTypeForDesign" required [class.invalid]="!generalForm.controls.pcbTypeForDesign.valid && generalForm.controls.pcbTypeForDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="casedesignreq2">b. Rigid Flex.</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" value="5" id="casedesignreq2" formControlName="pcbTypeForDesign" [(ngModel)]="generalRep.pcbTypeForDesign" required [class.invalid]="!generalForm.controls.pcbTypeForDesign.valid && generalForm.controls.pcbTypeForDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="casedesignreq3">c. Single-Sided Flex</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="casedesignreq3" value="2" formControlName="pcbTypeForDesign" [(ngModel)]="generalRep.pcbTypeForDesign" required [class.invalid]="!generalForm.controls.pcbTypeForDesign.valid && generalForm.controls.pcbTypeForDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="casedesignreq4">d. Double-Sided Flex</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="casedesignreq4" value="3" formControlName="pcbTypeForDesign" [(ngModel)]="generalRep.pcbTypeForDesign" required [class.invalid]="!generalForm.controls.pcbTypeForDesign.valid && generalForm.controls.pcbTypeForDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="casedesignreq5">e. Multi-layer Flex</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="casedesignreq5" value="4" formControlName="pcbTypeForDesign" [(ngModel)]="generalRep.pcbTypeForDesign" required [class.invalid]="!generalForm.controls.pcbTypeForDesign.valid && generalForm.controls.pcbTypeForDesign.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">

									    <div class="me-auto" style="width: 100%;">
									      <div>
									      	<label class="form-check-label" for="casedesignreq6">f. Any other?</label>
									      	<input type="radio" class="form-check-input me-1 float-end radio-options" id="casedesignreq6" value="6" formControlName="pcbTypeForDesign" [(ngModel)]="generalRep.pcbTypeForDesign" required [class.invalid]="!generalForm.controls.pcbTypeForDesign.valid && generalForm.controls.pcbTypeForDesign.dirty"/>
									      </div>
									      <textarea class="form-control textarea-height me-1 float-end mt-2" formControlName="pcbTypeForDesign_otherNotes" [(ngModel)]="generalRep.pcbTypeForDesign_otherNotes" required [class.invalid]="!generalForm.controls.pcbTypeForDesign_otherNotes.valid && generalForm.controls.pcbTypeForDesign_otherNotes.dirty"  (keyup)="onInputCheck($event,'pcbTypeForDesign_otherNotes',generalForm.get('pcbTypeForDesign_otherNotes')?.errors?.maxlength?.requiredLength)"  *ngIf="generalRep.pcbTypeForDesign == '6'"></textarea>
									    </div>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="u" class="col-sm-6 col-form-label">Please specify the board circuit operating speed:<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex">
									    <label class="form-check-label" for="circuitspeed1">a. Low speed    < 1Ghz </label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="circuitspeed1" value="1" formControlName="circuitBoardOperatingSpeed" [(ngModel)]="generalRep.circuitBoardOperatingSpeed" required [class.invalid]="!generalForm.controls.circuitBoardOperatingSpeed.valid && generalForm.controls.circuitBoardOperatingSpeed.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="circuitspeed2">b. Medium  >= 1Ghz    <= 5 Ghz</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="circuitspeed2" value="2" formControlName="circuitBoardOperatingSpeed" [(ngModel)]="generalRep.circuitBoardOperatingSpeed" required [class.invalid]="!generalForm.controls.circuitBoardOperatingSpeed.valid && generalForm.controls.circuitBoardOperatingSpeed.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="circuitspeed3">c. High      > 5 Ghz      RF</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="circuitspeed3" value="3" formControlName="circuitBoardOperatingSpeed" [(ngModel)]="generalRep.circuitBoardOperatingSpeed" required [class.invalid]="!generalForm.controls.circuitBoardOperatingSpeed.valid && generalForm.controls.circuitBoardOperatingSpeed.dirty"/>
									  </li>
									</ul>
								</div>
							</div>
							<div class="mb-3 row">
								<label for="v" class="col-sm-6 col-form-label">Select the nature of signals:<span class="require-mark">&lowast;</span></label>
								<div class="col-sm-4 offset-md-1">

									<ul class="list-group list-option-pl-0">
									  <li class="list-group-item border-0 d-flex">
									    <label class="form-check-label" for="naturesign1">a. Analog</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="naturesign1" value="1" formControlName="natureOfSignals" [(ngModel)]="generalRep.natureOfSignals" required [class.invalid]="!generalForm.controls.natureOfSignals.valid && generalForm.controls.natureOfSignals.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="naturesign2">b. Digital</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="naturesign2" value="2" formControlName="natureOfSignals" [(ngModel)]="generalRep.natureOfSignals" required [class.invalid]="!generalForm.controls.natureOfSignals.valid && generalForm.controls.natureOfSignals.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="naturesign3">c. Microwave requiring low loss</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="naturesign3" value="3" formControlName="natureOfSignals" [(ngModel)]="generalRep.natureOfSignals" required [class.invalid]="!generalForm.controls.natureOfSignals.valid && generalForm.controls.natureOfSignals.dirty"/>
									  </li>
									  <li class="list-group-item border-0 d-flex justify-content-between align-items-center">
									    <label class="form-check-label" for="naturesign4">d. Mixed signal</label>
									    <input type="radio" class="form-check-input me-1 float-end radio-options" id="naturesign4" value="4" formControlName="natureOfSignals" [(ngModel)]="generalRep.natureOfSignals" required [class.invalid]="!generalForm.controls.natureOfSignals.valid && generalForm.controls.natureOfSignals.dirty"/>
									  </li>
									</ul>
								</div>
							</div>
						<!-- </form> -->
					</div>
				</div>
			</div>
			<div class="card-container">
				<div class="container-title fwbold">Any other Information</div>
				<div class="row g-3 mt-3">
					<div class="col-12">
						<div class="mb-3 row">
							<label for="w" class="col-sm-4 col-form-label">Any Special Notes: </label>
							<div class="col-sm-5 pt-2">
								<textarea class="form-control textarea-height me-1 float-end" formControlName="customerNotes" [(ngModel)]="generalRep.customerNotes" required [class.invalid]="!generalForm.controls.customerNotes.valid && generalForm.controls.customerNotes.dirty" (keyup)="onInputCheck($event,'customerNotes',generalForm.get('customerNotes')?.errors?.maxlength?.requiredLength)"></textarea>
							</div>
						</div>
						<div class="mb-3 row">
							<label for="x" class="col-sm-4 col-form-label">Upload files:<span class="require-mark">&lowast;</span> </label>
							<div class="col-sm-4">
								<!-- <input type="file" class="form-control" id="fileUpload" value="" (change)="fileBrowseHandler($event.target)" onblur="this.value=''" /> -->
								<input type="file" class="form-control" id="fileUpload" formControlName="fileName" [(ngModel)]="fileName" (change)="fileBrowseHandler($event.target)"/>
							</div>
						</div>
						<div class="text-center mb-2"><strong><span class="require-color">Note :&nbsp;</span> <span class="fs12"> To upload multiple files, merge all those files into a single zip folder and then upload them here.</span></strong></div>
						<div class="row offset-md-4 fs12">
							<i>
								<b>Files required for quote:</b><br>
								<ol class="mb-0">
									<li>Schematic (PDF)</li>
									<!-- Commented based on DRF-42 -->
									<!-- <li>Tool Database (Allegro / Altium / Kicad / Eagle)</li> -->
									<li>BOM (Excel/CSV, PDF)</li>
									<li>Mechanical drawings (PDF)</li>
									<li>SOW (PDF) optional.</li>
								</ol> 
							</i> 
						</div>
						<!-- <div class="mb-3 row offset-md-3 fs12"> -->
						<div class="mb-3 row fs12 justify-content-center">
							<div class="col-sm-2" *ngFor="let fl of filesList; let i = index">
								<div class="card mb-2 text-bg-light" style="height: 100px;">
								<!-- <img src="..." class="card-img" alt="..."> -->
									<div class="card-img"></div>
									<div class="card-img-overlay" style="padding: 0rem;">
										<div class="card-title">{{fl.name}}</div>
										<div class="card-text">
											<div class="dib delete-file" (click)="removeFileList(i)"><i class="fas fa-trash"></i></div> 
											<div class="dib upload-file">
												<a (click)="downloadFile(i,upload_file)" #upload_file download><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row justify-content-center">
						<div class="col-3">
							<ngx-recaptcha2 #captchaElem
								[siteKey]="siteKey"
								formControlName="recaptcha"
								[(ngModel)]="generalRep.recaptcha"
								>
							</ngx-recaptcha2>
						</div>
					</div>
					<div class="col-12 text-center">
						<div> Please click the above check box and press Get Quote button</div>
						<p> In case you don't see <u>I'm not a robot</u> please refresh your page and try again.</p>
					</div>
				</div>
				<div class="col-12 text-center mt-3">
					<button type="submit" (click)="saveQuote()" class="btn btn-custom">
						GET QUOTE
					</button>
				</div>
			</div>
		</form>
	</div>
	<ngx-spinner bdColor = "rgba(232,237,242, 0.8)" size = "medium" color = "#6492e6" type = "ball-atom"><p style="font-size: 20px;color: #6492e6" > Loading... </p></ngx-spinner>
</section>